import * as _ from 'lodash';

export type BuildLocatorOpts = {
  isResolved: boolean,
  isRebuild: boolean,
  isLicenseOnlyRebuild: boolean;
  defaultOrganization: number,
  locatorsToRebuildRawContent: string,
};

export type BuildLocatorResponse = {
  msg: string,
};

/**
 * validates the values typings are correct
 */
export function isBuildLocatorOpts(
  value: BuildLocatorOpts | Record<string, unknown>,
): value is BuildLocatorOpts {
  if (!_.isObject(value)) {
    return false;
  }

  return [
    _.isBoolean(value.isResolved),
    _.isBoolean(value.isRebuild),
    _.isBoolean(value.isLicenseOnlyRebuild),
    _.isString(value.locatorsToRebuildRawContent),
    _.isNumber(value.defaultOrganization),
  ].every(check => !!check);
}

export type LocatorAndOrg = {
  locator: string;
  org: number;
}

/**
 * returns a list of orgs + locators to rebuild
 */
export function toOrgAndLocators(opts: BuildLocatorOpts): LocatorAndOrg[] {
  if (!opts.locatorsToRebuildRawContent.includes('+')) {
    return [];
  }

  return opts.locatorsToRebuildRawContent
    .split('\n')
    .map(l => l.trim())
    .filter(l => l !== '')
    .map(l => {
      if (l.match(/^\d+\s*,/)) {
        const orgAndLoc = l.split(',');
        const orgId = parseInt(orgAndLoc[0] || '', 10);
        const loc = orgAndLoc.slice(1).join(',').trim();
        return { org: orgId, locator: loc };
      }
      return { org: opts.defaultOrganization, locator: l };
    });
}
